import React, { useState, useEffect } from 'react'

import { useGetNearbyAdventuresLazyQuery } from 'hooks/useQueries'

import TrackVisibility from '../../../components/utils/TrackVisibility'
import { SectionTitle } from '../../listing/Sections/shared'

import SuggestedAdventures from '../SuggestedAdventures'

interface NearbyAdventuresProps {
  adventureId: string
}

const NearbyAdventures = ({ adventureId }: NearbyAdventuresProps) => {
  const [visible, setVisible] = useState(false)

  const [
    loadAdventures,
    { called, loading, data, fetchMore },
  ] = useGetNearbyAdventuresLazyQuery({
    variables: { id: adventureId },
  })

  useEffect(() => {
    if (visible) {
      loadAdventures()
    }
  }, [visible])

  const notYetFetched = loading || !called

  const handleFetchMore = () => {
    fetchMore({
      variables: {
        cursor: data?.adventure?.nearbyAdventures?.pageInfo?.endCursor,
      },
    })
  }

  const canFetchMore = data?.adventure.nearbyAdventures.pageInfo.hasNextPage
  const adventures = data?.adventure.nearbyAdventures

  return (
    <TrackVisibility
      onChange={(isVisible) => {
        if (isVisible) setVisible(true)
      }}
    >
      <SuggestedAdventures
        adventures={adventures}
        inItineraryContext={false}
        canFetchMore={canFetchMore}
        loading={notYetFetched}
        handleFetchMore={handleFetchMore}
        maxSlidesDesktop={3}
        customTitle={<SectionTitle>More Things To Do Nearby</SectionTitle>}
      />
    </TrackVisibility>
  )
}

export default NearbyAdventures
